<template>
  <section>
    <b-modal size="xl" :id="modalId" :ref="modalId" @show="resetModal">
      <template slot="modal-header">
        <h5 class="modal-title">Create Work Order</h5>
      </template>
      <div>
        <h6 class="mt-2">Purchase Order Line info to be created a work order</h6>
        <line-info isPOLineObj :detailObj="poLineDetail" />
        <hr/>
        <h6 class="mt-2">Select the test house that will perform.</h6>
        <b-row class="mt-2 mb-2">
            <b-col cols="5">
              <b-form-group label="Test House (to perform service)" class="required">
                <vue-simple-suggest
                  class="suggest-input form-control"
                  :class="{ 'is-invalid': $v.soInfoObj.companyId.$error }"
                  :styles="autoCompleteStyle"
                  :list="getListOfNames"
                  :max-suggestions="20"
                  :min-length="3"
                  :debounce="200"
                  :filter-by-query="true"
                  value-attribute="id"
                  display-attribute="name"
                  v-model="soInfoObj.companyName"
                  @select="onSuggestNameSelect"
                  @input="suggestNameChange"
                  @blur="$v.soInfoObj.companyId.$touch()"
                  @request-done="onRequestDone"
                >
                  <div slot="misc-item-below" v-if="isLoading" class="misc-item">
                    <span>Loading test houses...</span>
                  </div>
                </vue-simple-suggest>
                <div class="invalid-feedback">
                  <div v-if="!$v.soInfoObj.companyId.required">Test house is required</div>
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="3">
              <b-form-group label="Contact">
                  <b-form-select v-model="soInfoObj.contactId">
                    <option v-for="(select, index) in sortSelect(contacts,'firstName')" :key="index" :value="select.id">
                      {{ select.firstName + ' ' + select.lastName }}
                    </option>
                  </b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-form-group label="Date" class="required">
                <date-picker v-model="soInfoObj.soDate" :config="datePickerOptions" size="sm" :class="{ 'is-invalid': $v.soInfoObj.soDate.$error }"/>
                <div class="invalid-feedback">
                  <div v-if="!$v.soInfoObj.soDate.required">Date is required</div>
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-form-group label="Qty To Test" class="required">
                <b-form-input type="number" v-model="soInfoObj.qtyToTest" size="sm" :class="{ 'is-invalid': $v.soInfoObj.qtyToTest.$error }" />
                <div class="invalid-feedback">
                  <div v-if="!$v.soInfoObj.qtyToTest.required">Quantity is invalid</div>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group label="Instructions">
                <b-textarea v-model="soInfoObj.comments" rows="2"/>
              </b-form-group>              
            </b-col>
          </b-row>
          <div v-if="isExistPurchaseOrderLines">
            <h6>Note: A work order has already created for this purchase order line</h6>
            <service-order-lines :purchaseOrderLineId="poLineDetail.id"  />
          </div>
      </div>
      <template slot="modal-footer">
        <b-button @click="$bvModal.hide(modalId)">Cancel</b-button>
        <b-button variant="primary" @click="saveServiceOrder" :disabled="isSaving">
          <i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Create Work Order</b-button>
      </template>
    </b-modal>
  </section>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import debounce from 'lodash/debounce';
import VueSimpleSuggest from 'vue-simple-suggest';
import { required, between } from 'vuelidate/lib/validators';
import { DATE_FORMAT,GRID_PAGE_SIZES, AUTO_COMPLETE_STYLES } from '@/shared/constants';
import GridComponent from '@/shared/components/GridComponent';
import linesFields from './fields';
import { VENDOR_ID } from '@/shared/constants';
import { date } from '@/shared/filters';
import DateRangePicker from '@/shared/components/DateRangePicker';
import ServiceOrderLines from '@/shared/components/ServiceOrderLines';
import LineInfo from '@/pages/ServiceOrders/components/edit/components/ServiceOrderLineInfo';
const SEARCH_DEBOUNCE_TIME = 750;

export default {
  props:{
    poLineDetail: {
      type: Object,
      default: () => {},
    },
    isReturnId: {
      type: Boolean,
      default: false
    },
    qtyToTest: {
      type: Number,
      default: 0
    }
  },
  components: {
    DateRangePicker,
    VueSimpleSuggest,
    GridComponent,
    ServiceOrderLines,
    LineInfo
  },
  data() {
    return {
      date,
      linesFields,
      modalId: 'add-service-order-modal',
      gridId: 'add-service-order-grid',
      pageable: {
        pageSizes: GRID_PAGE_SIZES,
      },
      selectedRowItemId: 0,
      soInfoObj: {
        companyId: null,
        contactId: null,
        soDate: new Date(),
        qtyToTest: 0,
        comments: null
      },
      chosenName:  '',
      autoCompleteStyle: AUTO_COMPLETE_STYLES,
      datePickerOptions: {
          format: DATE_FORMAT,
          useCurrent: true,
      },
      isLoading: false,
      isSaving: false,
      selectedSO: {},
      filterPageName:'soFromPoPage'
    };
  },
  validations: {
    soInfoObj: {
      companyId: { required },
      soDate: { required },
      qtyToTest: { required }
    },
  },
  computed: {
    ...mapGetters('serviceOrders', [
      'serviceordersList',
      'pageInfo',
      'sortOrder',
      'filters',
    ]),
    // ...mapGetters('quoteAdd', [
    //   'customers',
    //   'vendors',
    //   'contacts',
    // ]),
    ...mapGetters('quoteAdd', [
      'contacts',
    ]),
    ...mapGetters('account', ['gridSettingsById']),
    ...mapGetters('serviceOrderLines', ['serviceOrderLineByPoLine']),
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
    itemData() {
      if(this.serviceordersList == undefined || this.serviceordersList.length === 0) return [];
      return this.serviceordersList.map((serviceorder) => ({ ...serviceorder, selected: serviceorder.id === this.selectedRowItemId }));
    },
    filterObj() {
      return this.filters[this.filterPageName] || {}
    },
    isExistPurchaseOrderLines() {
      return Object.keys(this.serviceOrderLineByPoLine).length > 0
        && this.serviceOrderLineByPoLine[0].purchaseOrderLineId == this.poLineDetail.id;
    }
  },
  methods: {
    // ...mapMutations('serviceOrders', ['clearFilters','setServiceordersList','setItem']),
    ...mapMutations('serviceOrders', ['setServiceordersList','setItem']),
    ...mapActions('serviceOrders', [
      'getAll',
      'search',
      'createServiceOrderFromPO'
    ]),
    ...mapActions('account', ['saveGridSettings']),
    ...mapActions('companies', ['getByNameAndAccountType']),
    // ...mapActions('quoteAdd', ['getContacts','clearContacts']),
    ...mapActions('quoteAdd', ['getContacts']),
    ...mapMutations('quoteAdd', {quoteAddSetItem: 'setItem'}),
    ...mapActions('serviceOrderLines', ['addLineToServiceOrder']),
    onSearch: debounce(function (data = false) {
      if(typeof data === 'object') { Object.assign(this.filterObj,data) }
      this.search({'filters':this.filterObj,page:this.filterPageName});
    }, SEARCH_DEBOUNCE_TIME),
    onClear() {
      /*Object.keys(this.filterObj).forEach(filterName => {
        this.filterObj[filterName] = null;
      });*/
      this.clearObject(this.filterObj);
    },
    async onRowClick(row) {
      if(this.selectedRowItemId != row.dataItem.id){
        this.selectedRowItemId = row.dataItem.id;
        this.selectedSO =  row.dataItem;
      }
    },
    async onGetData(params) {
      await this.getAll(params);
    },
    async onSuggestNameSelect(suggestion) {
      this.soInfoObj.companyId = suggestion.id;
      this.getContacts(suggestion.id);
      this.onClear()
      this.filterObj.statusId = 316;
      this.filterObj.companyId =  suggestion.id;
      this.onSearch();
    },
    async suggestNameChange(val) {
      this.isLoading = true;
      if (val === '') {
        this.resetModal();
      }
    },
    async getListOfNames(name) {
      return await this.getByNameAndAccountType({
        typeId: VENDOR_ID, name});
    },
    async resetModal() {
      Object.keys(this.soInfoObj).forEach(soKey => {
        this.soInfoObj[soKey] = null;
      });
      this.soInfoObj.soDate = new Date();
      this.soInfoObj.qtyToTest = this.qtyToTest;
      // this.clearContacts();
      this.quoteAddSetItem({ resource: 'contacts', payload: [] });
      this.onClear();
      this.setServiceordersList({
        items: [],
        paging: {...this.pageInfo,totalItems:0},
        sort: this.pageInfo.sort,
        sortOrder: this.pageInfo.sortOrder,
      });
    },
    onRequestDone() {
      this.isLoading = false;
    },
    async addToPendingSO(){
      let insertData = [{
        id: 0,
        statusId: this.poLineDetail.statusId,
        serviceOrderId: this.selectedSO.id,
        purchaseOrderLineId: this.poLineDetail.id,
        quantity: this.soInfoObj.qtyToTest,
      }];
      try {
        this.isSaving = true;
        await this.addLineToServiceOrder(insertData);
        this.isSaving = false;
        this.resetModal();
        this.$bvModal.hide(this.modalId);
        this.$router.push({name: 'serviceorders.edit', params: {id: this.selectedSO.id}});
      } catch (e) {
        this.isSaving = false;
        /*console.log(e.message);*/
      }
    },
    async saveServiceOrder() {
      this.$v.soInfoObj.$touch();
      if (this.$v.soInfoObj.$invalid) {
        return;
      }
        const data = {
          poToServiceOrder: {
            id: 0,
            purchaseOrderId:this.poLineDetail.purchaseOrderId,
            companyId: this.soInfoObj.companyId,
            contactId: this.soInfoObj.contactId,
            soDate: new Date(this.soInfoObj.soDate).toISOString(),
            currencyTypeId: 1,
            exchangeRate: 1
          },
          poLinesToServiceOrderLines: [{
              purchaseOrderLineId: this.poLineDetail.id,
              quantity: this.soInfoObj.qtyToTest,
              comments: this.soInfoObj.comments,
              id: 0,
            }]
          };
      try {
        this.isSaving = true;
        const id = await this.createServiceOrderFromPO(data);
        this.isSaving = false;
        this.resetModal();
        this.$bvModal.hide(this.modalId);
        if (id > 0) {
          if (!this.isReturnId) {
            this.$router.push({name: 'serviceorders.edit', params: {id}});S
          } else {
            this.$emit('newWorkOrder', {id,companyId:data.poToServiceOrder.companyId});
          }
        }
      } catch (e) {
        this.isSaving = false;
        /*console.log(e.message);*/
      }
    }
  },
  watch: {
    pageInfo: function(newPageInfo) {
      this.pageNumber = newPageInfo.pageNumber;
      this.take = newPageInfo.pageSize;
    },
    take(pageSize) {
      this.saveGridSettings({
        id: this.gridId,
        settings: {
          ...this.gridSettings,
          pageSize,
        },
      });
    },
  },
  async mounted() {
    this.setItem({ resource:'filterPage', payload: this.filterPageName });
  },
};
</script>
